/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SlideFlag } from './SlideFlag';

export type LISCaseListSlide = {
    readonly id?: number;
    /**
     * slide number in the provided block
     */
    slide_number?: string | null;
    lis_state?: LISCaseListSlide.lis_state | null;
    readonly block_obj_id?: number;
    readonly stain_id?: number;
    readonly lab_order_id?: number;
    readonly created_at?: string;
    readonly antigen_retrieval_method_id?: number;
    readonly antibody_species_id?: number;
    readonly flags?: Array<SlideFlag>;
    readonly label_override?: string;
    readonly is_control?: boolean;
}

export namespace LISCaseListSlide {

    export enum lis_state {
        UNSTAINED = 'unstained',
        RACKED = 'racked',
        STAINED = 'stained',
        SCANNING = 'scanning',
        SCANNED = 'scanned',
    }


}
